import { render, staticRenderFns } from "./svgReview.vue?vue&type=template&id=f00b8abc&scoped=true&"
import script from "./svgReview.vue?vue&type=script&lang=js&"
export * from "./svgReview.vue?vue&type=script&lang=js&"
import style0 from "./svgReview.vue?vue&type=style&index=0&id=f00b8abc&scoped=true&lang=css&"
import style1 from "./svgReview.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00b8abc",
  null
  
)

export default component.exports